import { Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

const CVCthree = () => {
  const info = [
    'Gây tê cục bộ tại chỗ chèn để giảm đau trong quá trình phẫu thuật.',
    'Sau khi chọc thủng mạch máu bằng kim tiêm, một đầu dẫn được chèn vào kim để đảm bảo một lối đi cho dây dẫn dễ dàng chèn ống thông.',
    'Ống thông được đưa vào mạch máu thông qua đầu vào, và ống thông được gắn chặt vào da.',
    'Thời gian dự kiến khoảng 20 đến 40 phút, nhưng có thể thay đổi tùy theo tiến trình của thủ tục.',
  ];

  return (
    <Fragment>
      <SectionTitle title="3. Phương pháp chèn ống thông tĩnh mạch trung tâm." />
      <Box sx={{ margin: '38px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          {info.map(a => {
            return (
              <Grid item xs={11.5}>
                <Typography sx={{ fontSize: '14px', lineHeight: '30px' }}>
                  • {a}
                </Typography>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Fragment>
  );
};

export default CVCthree;
